module.exports = __webpack_public_path__ + "assets/24e8143451e041b22f15e8481fa6e8a4.svg";